import React, { useEffect, useState } from "react";

export default function UploadTrackerAdmin() {
  const [uploads, setUploads] = useState([]);

  useEffect(() => {
    const fetchUploads = async () => {
      const response = await fetch("/uploads");
      const data = await response.json();
      setUploads(data);
    };

    fetchUploads();
    const interval = setInterval(fetchUploads, 5000); // Refresh every 5 seconds

    return () => clearInterval(interval);
  }, []);

  return (

    <div className="settingsPreferencesGroupingDiv">
        <div className="settingsPreferences settingsUsersList">
          <div className="settingsComponentHeading">Ongoing Uploads</div>
          <div className="settingsPreferencesGroup1">
          <table className="table">
            <thead>
              <tr>
                <th>Progress</th>
                <th>Project</th>
                <th>Service</th>
                <th>User</th>
                <th>Start Time</th>
              </tr>
            </thead>
            <tbody>
              {uploads.map(upload => (
                <tr key={upload.id}>
                  <td>{upload.progress}%</td>
                  <td>{upload.address}</td>
                  <td>{upload.service_title}</td>
                  <td>{upload.user_name}</td>
                  <td>{new Date(upload.created_at).toLocaleString("en-US", {
                    weekday: "short",  // 'Mon', 'Tue', etc.
                    month: "short",    // 'Jan', 'Feb', etc.
                    day: "numeric",    // '9', '10', etc.
                    year: "numeric",   // '2024'
                    hour: "2-digit",   // '03'
                    minute: "2-digit", // '30'
                    hour12: true       // 12-hour format (true) or 24-hour format (false)
                  })}</td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
    </div>
  );
}